export default function featurePanel() {
  const featurePanel = document.querySelector(".features-panel");
  if (!featurePanel) return;

  const items = featurePanel.querySelectorAll(".feature-item");

  // const isDesktop = () => window.innerWidth > 950;

  const isDesktop = () => window.innerWidth >= 1060;

  featurePanel.addEventListener("mouseenter", () => {
    if (isDesktop()) {
      featurePanel.classList.add("is-hovering");
    }
  });

  featurePanel.addEventListener("mouseleave", () => {
    if (isDesktop()) {
      featurePanel.classList.remove("is-hovering");
    }

    setTimeout(() => {
      items.forEach((item) =>
        item.classList.remove("is-active", "show-content"),
      );
    }, 100);
  });

  items.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      // Reset all items
      items.forEach((i) => i.classList.remove("is-active", "show-content"));

      if (isDesktop()) {
        item.classList.add("is-active");
      }

      // Delay content until hover state is fully expanded
      setTimeout(() => {
        if (item.classList.contains("is-active")) {
          if (isDesktop()) {
            item.classList.add("show-content");
          }
        }
      }, 100);
    });
  });
}
